import * as moment from 'moment';
import { Injectable } from '@angular/core';

import { WorkoutModel, WorkoutExerciseModel, WorkoutExerciseSetModel } from '../../models/models';
import { ApiProvider } from '../api/api';
import { ExerciseProvider } from '../exercise/exercise';

const unique = function(lst, selector) {
  return lst.filter((e, i) => lst.findIndex((a) => {
     if (selector) {
       return selector(a) === selector(e);
     }
     return a === e;
   }) === i);
};

@Injectable()
export class WorkoutProvider {
  private items: WorkoutModel[] = [];

  constructor(
    private api: ApiProvider,
    private exerciseProvider: ExerciseProvider,
    ) {
  }

  AddExercise(workout: WorkoutModel, index: number, exercise: WorkoutExerciseModel = new WorkoutExerciseModel()) {
    exercise._id = null;
    exercise.SortOrder = index + 1;
    exercise.Sets = [{
      _id: null,
      Reps: null,
      Weight: null,
      SortOrder: 1
    }];
    workout.Exercises.map(x => {
      if (x.SortOrder > index) {
        x.SortOrder++
      }
    });
    workout.Exercises.splice(index, 0, exercise);
    return exercise;
  }

  AddExerciseSet(exercise: WorkoutExerciseModel, sort_order: number, set = new WorkoutExerciseSetModel()) {
    set._id = null;
    set.SortOrder = sort_order;
    exercise.Sets.map(x => {
      if (x.SortOrder >= sort_order) {
        x.SortOrder++
      }
    });
    exercise.Sets.splice(sort_order - 1, 0, set);
    return set;
  }

  Delete(id: number) {
    return new Promise((resolve, reject) => {
      this.api.delete('workout/' + id).subscribe((res) => {
        const data = res.json();
        if (data.success) {
          resolve(true);
        }
        resolve(false);
      });
    });
  };

  async DeleteExercises(ids: number[]) {
    return new Promise((resolve, reject) => {
      this.api.post('workout/exercise/delete/', ids).subscribe((res) => {
        const data = res.json();
        if (data.success) {
          resolve(true);
        }
        resolve(false);
      });
    });
  };

  async DeleteExerciseSets(ids: number[]) {
    return new Promise((resolve, reject) => {
      this.api.post('workout/exercise/set/delete/', ids).subscribe((res) => {
        const data = res.json();
        if (data.success) {
          resolve(true);
        }
        resolve(false);
      });
    });
  }

  Load(workout) {
    return new Promise((resolve, reject) => {
      if (workout._id) {
        this.api.get(`workout/${workout._id}`).subscribe((res) => {
          const data = res.json();
          this.BuildWorkout(workout, data);
          resolve(workout);
        });
      }
      else {
        workout = new WorkoutModel();
        workout._id = null;
        workout.Time = moment().format('HH:mm');
        workout.Exercises = [{
          FullName: '(choose)',
          Sets: [{ Weight: null, Reps: null, SortOrder: 1 }],
          SortOrder: 1
        }];
        workout.MaxSets = [0];
        resolve(workout);
      }
    });
  }

  List(user_id, start, end) {
    return new Promise((resolve, reject) => {
      this.api.get(`workout/${user_id}/${start}_${end}`).subscribe((data) => {
        const arr = data.json();
        let obj: WorkoutModel[] = [];
        for(let j = 0; j < arr.length; j++) {
          let item = arr[j];
          const time = moment(item.time, 'H:mm');
          const workout = {
            _id: item.id,
            UserId: user_id,
            Date: moment(item.date, 'YYYY-MM-DD'),
            Time: time.format('HH:mm'),
            TimeDisplay: time.format('hh:mm a'),
            Name: item.name,
            Notes: item.notes,
            LastWorkoutId: item.last_workout_id
          };
          obj.push(workout);
        }
        this.items = obj;
        resolve(this.items);
      });
    });
  }

  RemoveExercise(workout: WorkoutModel, exercise: WorkoutExerciseModel) {
    workout.Exercises.map(x => {
      if (x.SortOrder > exercise.SortOrder) {
        x.SortOrder--;
      }
    });
    workout.Exercises = workout.Exercises.filter(x => x !== exercise);
    this.SetMaxSets(workout);
  }

  RemoveExerciseSet(exercise: WorkoutExerciseModel, set: WorkoutExerciseSetModel) {
    exercise.Sets.map(x => {
      if (x.SortOrder > set.SortOrder) {
        x.SortOrder--;
      }
    });
    exercise.Sets = exercise.Sets.filter(x => x !== set);
  }

  Save(workout: WorkoutModel) {
    return new Promise((resolve, reject) => {
      if (!workout.Notes) {
        workout.Notes = null;
      }
      this.api.post(`workout/${workout._id}`, workout).subscribe((res) => {
        const data = res.json();
        workout._id = data.id;  // set workout id
        workout.Exercises.map((e, i) => {
          e._id = data.exercises[i].id; // set exercise id
          e.Sets.map((s, j) => s._id = data.exercises[i].sets[j].id); // set id
        });
        resolve(data);
      });
    });
  }

  SetMaxSets(workout) {
    workout.MaxSets = Array(Math.max.apply(Math, workout.Exercises.map(x => x.Sets.length)));
  }

  Sort() {
    this.items.sort((a: WorkoutModel, b: WorkoutModel) => {
      if (moment(a.Date + ' ' + a.Time) > moment(b.Date + ' ' + a.Time)) return 1;
      else if (moment(a.Date + ' ' + a.Time) < moment(b.Date + ' ' + a.Time)) return -1;
      else return 0;
    });
    return this.items;
  }

  private BuildWorkout(workout, data) {
    let exercises = data.map((item) => { 
      return { 
        _id: item.workout_exercise_id, 
        ExerciseId: item.exercise_id,
        Name: item.exercise_name, 
        Variation: item.variation,
        SortOrder: item.sort_order
      };
    });
    workout.Exercises = unique(exercises, item => item._id);
    for(let j = 0; j < workout.Exercises.length; j++) {
      let exercise = workout.Exercises[j];
      this.exerciseProvider.SetFullName(exercise);
      exercise.Sets = data.filter(x => x.workout_exercise_id === exercise._id).map(item => {
        return {
          _id: item.workout_exercise_set_id,
          Weight: item.weight,
          Reps: item.reps,
          SortOrder: item.set
        };
      });
    }
    this.SetMaxSets(workout);
  }

}


// WEBPACK FOOTER //
// ./src/providers/workout/workout.ts